class ContentWithTabs extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('.content-with-tabs__list');
    this.panels = this.querySelector('.content-with-tabs__panels');
    this.tabs = [];

    this.querySelectorAll('.content-with-tabs__tab-item').forEach((tab) => {
      const panel = this.getPanel(tab);

      if (!panel) {
        tab.closest('.content-with-tabs__tab')?.remove();
        return;
      }

      if (this.panels) {
        this.panels.appendChild(panel);
      }

      this.tabs.push(tab);
    });

    if (!this.tabs.length) return;

    this.tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('tabindex', index === 0 ? '0' : '-1');
      tab.addEventListener('click', () => this.activate(index));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    this.activate(0);
  }

  onKeydown(event, index) {
    const { key } = event;
    let nextIndex = null;

    if (key === 'ArrowRight' || key === 'ArrowDown') {
      nextIndex = (index + 1) % this.tabs.length;
    } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
      nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    } else if (key === 'Home') {
      nextIndex = 0;
    } else if (key === 'End') {
      nextIndex = this.tabs.length - 1;
    }

    if (nextIndex === null) return;

    event.preventDefault();
    this.activate(nextIndex);
    this.tabs[nextIndex].focus();
  }

  getPanel(tab) {
    const sibling = tab.nextElementSibling;
    if (sibling && sibling.classList.contains('tab-image-content')) {
      return sibling;
    }

    return tab.parentElement?.querySelector('.tab-image-content') || null;
  }

  getPanelByIndex(index) {
    if (!this.panels) return null;
    return this.panels.querySelectorAll('.tab-image-content')[index] || null;
  }

  activate(index) {
    this.tabs.forEach((tab, i) => {
      const isActive = i === index;
      const panel = this.getPanelByIndex(i);

      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');

      if (panel) {
        panel.classList.toggle('active', isActive);
      }
    });
  }
}

customElements.define('content-with-tabs', ContentWithTabs);
